import { render, staticRenderFns } from "./SubmissionFormView.vue?vue&type=template&id=4b7f2320&"
import script from "./SubmissionFormView.vue?vue&type=script&lang=js&"
export * from "./SubmissionFormView.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionFormView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports